import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Image from "../../../image/image";
import ErrorBoundary from "../../../../error-boundary";
import DashedCorners from "@default/general-components/dashed-corners";

const ParagraphQuote = ({ content }) => {
  const { fieldImage = null, fieldText, fieldSource, fieldHighlighted, fieldDarkMode } = content;

  const sectionClassNames = classNames({
    "paragraph paragraph-quote": true,
    "with-image": fieldImage,
    "no-image": !fieldImage,
    "highlighted ": fieldHighlighted,
    standard: !fieldHighlighted
  });

  return (
    <section className={sectionClassNames} data-darkmode={fieldDarkMode}>
      <div className="container">
        <div className="row">
          {fieldImage !== null && (
            <div className="col-12 col-lg-5 image-col">
              <ErrorBoundary>
                <Image
                  data={fieldImage.fieldMediaImage}
                  className="quote-image"
                />
              </ErrorBoundary>
            </div>
          )}
          <div
            className={classNames({
              "col-12 quote-col": true,
              "col-lg-7": fieldImage,
            })}
          >
            <blockquote className={"text"}>

              <DashedCorners />

              <div className="text">{`« ${fieldText.replace(/<\/?[^>]+(>|$)/g, "")} »`}</div>
              <cite>{fieldSource}</cite>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
};

ParagraphQuote.propTypes = {
  viewMode: PropTypes.string,
  content: PropTypes.shape({
    fieldImage: PropTypes.shape({
      fieldMediaImage: PropTypes.object,
    }),
    fieldText: PropTypes.string.isRequired,
    fieldSource: PropTypes.string.isRequired,
  }),
};

export default ParagraphQuote;
